import { FiltroGeneracionMasiva } from "../models/filtroGeneracionMasiva";
import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import Conversiones from "../../../../utils/conversiones";
import { GenerarArchivoInput } from "../models/generarArchivoInput";
import { RespuestaArchivoEndosoDto } from "../models/respuestaArchivoEndoso";
import { GenerarLiquidacionEndosoDto } from "../models/generarLiquidacionEndosoDto";
import { RespuestaLiquidacionEndosoDto } from "../models/respuestaLiquidacionEndosoDto";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { RowGeneracionMasiva } from "../models/rowGeneracionMasiva";

const filtrarOperacionesGeneracionMasiva = async (filtros: FiltroGeneracionMasiva) => {
    const formatFechaDesde : string = Conversiones.formatDateReverse(filtros.fechaDesde, "-");

    const url = `siscred-api-cartera-total/v1/endosos/filtrarmasivo?fechaDesde=${formatFechaDesde}&rutInversionista=${filtros.inversionista}`
    const response: Promise<AxiosResponse<ListResponseDto<RowGeneracionMasiva>>> = axiosInstance.get(url);
    return response;                         
}

const generarArchivo = async (filtros: GenerarArchivoInput) => {
    const url = `siscred-api-reportes/v1/archivo-externo/generararchivoendoso`
    const response: Promise<AxiosResponse<RespuestaArchivoEndosoDto>> = axiosInstance.post(url, filtros);
    return response;
}

const generarLiquidacion = async (filtros: GenerarLiquidacionEndosoDto) => {
    const url = `siscred-api-reportes/v1/endosos/generar-liquidacion-endoso`
    const response: Promise<AxiosResponse<RespuestaLiquidacionEndosoDto>> = axiosInstance.post(url, filtros);
    return response;
}

export { filtrarOperacionesGeneracionMasiva, generarArchivo, generarLiquidacion }

